import { api } from 'pages/APIs';
import type { dynamicObj } from 'src/pages/assets';
import { useDropdownStore } from 'src/store/main';
import AbstractApiService from 'src/services/abstractApiService';

export default class ListOfValuesApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getLists(add_values = false): Promise<any> {
    const data = {} as dynamicObj;
    if (add_values) {
      data['add_values'] = add_values;
    }
    const sub_org_id = await this.getSubOrgId();
    if (sub_org_id) {
      data['sub_org_id'] = '';
    }
    const querystring = this.encodeQueryData(data);
    return super.get(api.get_lov_list + '?' + querystring, {});
  }

  public async createList(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.post(api.create_lov_type, formData);
  }

  public async deleteList(list_name: string): Promise<any> {
    const formData = new FormData();
    formData.append('name', list_name);
    return super.delete(api.delete_lov_type, formData);
  }
  public async getValueByParentOrg(names: string[]): Promise<any> {
    const data = {} as dynamicObj;
    const org_id = this.getOrgId();
    if (org_id) {
      data['org_id'] = org_id;
    }
    const parent_org_id = this.getParentOrgId();
    if (parent_org_id) {
      data['parent_org_id'] = parent_org_id;
    }
    const querystring = this.encodeQueryData(data);
    return super.get(api.get_lov_value_by_parent_org + '?' + querystring, {});
  }
  public async getValuesForList(
    list_name: string,
    use_sub_org = true,
  ): Promise<any> {
    const data = {} as dynamicObj;
    data['name'] = list_name;
    if (use_sub_org) {
      const sub_org_id = await this.getSubOrgId();
      if (sub_org_id && sub_org_id !== this.getOrgId()) {
        data['sub_org_id'] = sub_org_id;
      }
    }

    const querystring = this.encodeQueryData(data);
    return super.get(api.get_list_of_values + '?' + querystring, {});
  }

  public async getMultipleListOfValues(list_names: string): Promise<any> {
    const dropdown_store = useDropdownStore();

    const data = {} as dynamicObj;
    data['names'] = list_names;
    data['language_code'] = dropdown_store.getSelectedLanguage();
    const sub_org_id = await this.getSubOrgId();
    if (sub_org_id && sub_org_id !== this.getOrgId()) {
      data['sub_org_id'] = sub_org_id;
    }
    const querystring = this.encodeQueryData(data);
    return super.get(api.get_multiple_list_of_values + '?' + querystring, {});
  }

  public async createValuesForlist(data: any): Promise<any> {
    return super.post(api.create_lov_value, data);
  }

  public async duplicateValues(data: { ids: string }): Promise<any> {
    const formData = new FormData();
    formData.append('ids', data.ids);
    return super.post(api.duplicate_lov_value, formData);
  }

  public async createMultiLangValuesForlist(data: any): Promise<any> {
    return super.post(api.create_lov_values, data);
  }

  public async editMultiLangValuesForList(data: any): Promise<any> {
    return super.put(api.update_lov_values, data);
  }

  public async deleteValue(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.delete(api.delete_lov_value, formData);
  }

  public async editValueForlist(data: any): Promise<any> {
    return super.post(api.update_lov_value, data);
  }

  public async importValuesForList(formData: FormData): Promise<any> {
    return super.post(api.import_lov, formData);
  }
}
